import { render, staticRenderFns } from "./SettingBox.vue?vue&type=template&id=694061d4&scoped=true&"
import script from "./SettingBox.vue?vue&type=script&lang=ts&"
export * from "./SettingBox.vue?vue&type=script&lang=ts&"
import style0 from "./SettingBox.vue?vue&type=style&index=0&id=694061d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694061d4",
  null
  
)

export default component.exports